import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";

import { login, signFailed, signUpSuccess } from "../../redux/actions/auth";

import ModalComponent from "../../components/Modal";

import { Link, useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";

// import SelectLabels from "../../components/SelectLabels";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import authReducer from "../../redux/reducers";
import { toast, ToastContainer } from "react-toastify";
import LoginLoader from "../../components/LoginLoader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import {
  IconButton,
  InputAdornment,
  ThemeProvider,
  createTheme,
  Backdrop,
  Button,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import Recaptcha from "react-recaptcha";
import Loader from "../../components/Loader";
import firebird from "../../assets/images/firebird.png";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import AbcIcon from "@mui/icons-material/Abc";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
const customId1 = "custom-id-yess";

function SignUpRegister(props) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = React.useState(0);
  const [verified, setVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const [statusMann, setStatusMann] = useState();

  const theme = createTheme({
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const statusMan = useSelector((state) => state.authReducer.Signinstatus);

  // console.log(statusMan, statusMan == true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (statusMan == true) {
      setTimeout(async () => {
        await history.push("/");
        dispatch(signFailed());
      }, 5000);
    }
  }, [statusMan]);

  const validationSchema = yup.object({
    username: yup
      .string("Enter Your Username")
      .min(3, "Username should be at least 3 characters long")
      .required("*Username is required")
      .matches(/^(\S+$)/g, "* This field cannot contain  blankspaces"),
    password: yup
      .string()
      .required("Please Enter your  password")
      .min(8)
      .max(12)
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        "Must Contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    name: yup
      .string("Enter your Name")
      .min(2, "Name should be of minimum 2 characters length")
      .required("Name is required"),
    email: yup
      .string()
      .email("E-Mail must be valid")
      .max(255)
      .required("E-Mail  is required"),
    phoneNumber: yup
      .number("Enter  Phone Number ")
      .min(
        1000000000,
        "Phone Number  should be of minimum 10 characters length"
      )
      .max(
        10000000000,
        "Phone Number  should be of maximum 11 characters length"
      )
      .required("Phone is required"),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      name: "",
      email: "",
      phoneNumber: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        // console.log(values.password);
        // console.log(values.password);
        // console.log(value);

        props.signUpSuccess(
          values.username,
          values.password,
          values.name,
          values.email,
          values.phoneNumber
        );
      } catch (error) {
        // console.log(error);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });
  return (
    <>
      <main class="main-content my-aut lgin_cntnt position-relative w-auto  border-radius-l  ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          <ToastContainer autoClose={5000} />
          <div class="container-fluid px-0">
            <div class="row d-md-flex d-none h_vh align-items-cente mx-0">
              <div class="col-md-7 bg_18 d-flex ">
                <div class="ps_8 my-auto py_5">
                  <img src={firebird} class="img-fluid d-block mx-auto" />
                  <p class="text-center m-0 my-4 fw-bold">
                    FIREBIRD, An Omni Channel Solution which broadens
                    Communication channels to Telecom operators. Its an
                    integrated platform to meet the Business requirements with
                    respect to Messaging solutions and Voice solutions.
                  </p>
                  <div
                    class="d-flex justify-content-center align-items-center fw-bold"
                    style={{ color: "#000" }}
                  >
                    <p style={{ fontWeight: "bold" }}>Want to contact us ?</p>
                    <Link to="/contactus">
                      <Button variant="contained">Contact US --> </Button>
                    </Link>
                  </div>
                </div>
              </div>
              <div
                class="col-md-5 d-flex align-items-center bg_8 p-4"
                style={{ padding: "3.5rem" }}
              >
                <div class="w-100">
                  <form onSubmit={formik.handleSubmit}>
                    <div class="">
                      <div class="">
                        <div class="text-center">
                          <LockOpenIcon
                            style={{
                              fontSize: "25px",

                              color: "white",
                              border: "0.5px solid #0083AD",
                              borderRadius: "30px",
                              backgroundColor: "#0083AD",
                            }}
                          />
                        </div>
                        <div class="text-center mt-2">
                          <span class="d-inline-block text-capitalize">
                            sign up
                          </span>
                        </div>
                      </div>
                      <div class="my-4">
                        <span> </span>
                        <div class="input-group input-group-outline input_field">
                          <div className="col-md-12 d-inline-flex">
                            <div className="me-2 mt-3">
                              <PersonIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Username"
                              name="username"
                              variant="standard"
                              size="small"
                              // type="email"

                              value={formik.values.username}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.username &&
                                Boolean(formik.errors.username)
                              }
                              helperText={
                                formik.touched.username &&
                                formik.errors.username
                              }
                            />
                          </div>
                        </div>

                        <div class="input-group input-group-outline input_field my-4">
                          <div className="col-md-12 d-inline-flex">
                            <div className="me-2 mt-3">
                              <LockIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Password"
                              name="password"
                              type={showPassword ? "text" : "password"}
                              variant="standard"
                              size="small"
                              value={formik.values.password}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.password &&
                                Boolean(formik.errors.password)
                              }
                              helperText={
                                formik.touched.password &&
                                formik.errors.password
                              }
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={handleClickShowPassword}
                                      onMouseDown={handleMouseDownPassword}
                                    >
                                      {showPassword ? (
                                        <VisibilityIcon
                                          sx={{ color: "#85CBF2" }}
                                        />
                                      ) : (
                                        <VisibilityOffIcon
                                          sx={{ color: "#85CBF2" }}
                                        />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        </div>

                        <div class="input-group input-group-outline input_field">
                          <div className="col-md-12 d-inline-flex">
                            <div className="me-2 mt-3">
                              <AbcIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Name"
                              name="name"
                              variant="standard"
                              size="small"
                              value={formik.values.name}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.name &&
                                Boolean(formik.errors.name)
                              }
                              helperText={
                                formik.touched.name && formik.errors.name
                              }
                            />
                          </div>
                        </div>

                        <div class="input-group input-group-outline input_field my-4">
                          <div className="col-md-12 d-inline-flex">
                            <div className="me-2 mt-3">
                              <EmailIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="E-mail"
                              name="email"
                              variant="standard"
                              type="email"
                              size="small"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.email &&
                                Boolean(formik.errors.email)
                              }
                              helperText={
                                formik.touched.email && formik.errors.email
                              }
                            />
                          </div>
                        </div>

                        <div class="input-group input-group-outline input_field mb-3">
                          <div className="col-md-12 d-inline-flex">
                            <div className="me-2 mt-3">
                              <LocalPhoneIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Phone Number"
                              name="phoneNumber"
                              variant="standard"
                              size="small"
                              type="number"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 10);
                              }}
                              value={formik.values.phoneNumber}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.phoneNumber &&
                                Boolean(formik.errors.phoneNumber)
                              }
                              helperText={
                                formik.touched.phoneNumber &&
                                formik.errors.phoneNumber
                              }
                            />
                          </div>
                        </div>
                        <button
                          type="submit"
                          class="btn bg-gradient-primary register_grad d-block w-100 my-4"
                        >
                          Sign Up
                        </button>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="text-start fw-bold">
                              <a
                                href="#"
                                onClick={formik.handleReset}
                                class="text-capitalize link-info"
                              >
                                Reset
                              </a>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div
                              class="text-end  fw-bold link-info"
                              id="sign_up_in"
                            >
                              <Link to="/" class="text-capitalize">
                                Log In
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <LoginLoader visible={props.loading} />
              </div>
            </div>
          </div>
        </ThemeProvider>
        <div class="d-md-none d-flex bg_18 h_vh">
          <div class="w-100 my-auto px_15 py-5">
            <div class="bg_8 p-4">
              <div class="w-100">
                <form onSubmit={formik.handleSubmit}>
                  <div class="">
                    <div class="">
                      <div class="text-center">
                        <LockOpenIcon
                          style={{
                            fontSize: "25px",

                            color: "white",
                            border: "0.5px solid #0083AD",
                            borderRadius: "30px",
                            backgroundColor: "#0083AD",
                          }}
                        />
                      </div>
                      <div class="text-center mt-2">
                        <span class="d-inline-block text-capitalize">
                          sign up
                        </span>
                      </div>
                    </div>
                    <div class="my-4">
                      <span> </span>
                      <div class="my-4">
                        <div className="d-flex">
                          <div className="me-2 mt-3">
                            <PersonIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="Username"
                            name="username"
                            variant="standard"
                            size="small"
                            // type="email"

                            value={formik.values.username}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.username &&
                              Boolean(formik.errors.username)
                            }
                            helperText={
                              formik.touched.username && formik.errors.username
                            }
                          />
                        </div>
                      </div>

                      <div class="my-4">
                        <div className="d-flex">
                          <div className="me-2 mt-3">
                            <LockIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="Password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            variant="standard"
                            size="small"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.password &&
                              Boolean(formik.errors.password)
                            }
                            helperText={
                              formik.touched.password && formik.errors.password
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {showPassword ? (
                                      <VisibilityIcon
                                        sx={{ color: "#85CBF2" }}
                                      />
                                    ) : (
                                      <VisibilityOffIcon
                                        sx={{ color: "#85CBF2" }}
                                      />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      </div>

                      <div class="my-4">
                        <div className=" d-flex">
                          <div className="me-2 mt-3">
                            <AbcIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="Name"
                            name="name"
                            variant="standard"
                            size="small"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.name && Boolean(formik.errors.name)
                            }
                            helperText={
                              formik.touched.name && formik.errors.name
                            }
                          />
                        </div>
                      </div>

                      <div class="my-4">
                        <div className="d-flex">
                          <div className="me-2 mt-3">
                            <EmailIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="E-mail"
                            name="email"
                            variant="standard"
                            type="email"
                            size="small"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.email &&
                              Boolean(formik.errors.email)
                            }
                            helperText={
                              formik.touched.email && formik.errors.email
                            }
                          />
                        </div>
                      </div>

                      <div class=" my-4">
                        <div className="d-flex">
                          <div className="me-2 mt-3">
                            <LocalPhoneIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="Phone Number"
                            name="phoneNumber"
                            variant="standard"
                            size="small"
                            type="number"
                            onInput={(e) => {
                              e.target.value = Math.max(
                                0,
                                parseInt(e.target.value)
                              )
                                .toString()
                                .slice(0, 10);
                            }}
                            value={formik.values.phoneNumber}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.phoneNumber &&
                              Boolean(formik.errors.phoneNumber)
                            }
                            helperText={
                              formik.touched.phoneNumber &&
                              formik.errors.phoneNumber
                            }
                          />
                        </div>
                      </div>
                      <button
                        type="submit"
                        class="btn bg-gradient-primary register_grad d-block w-100 my-4"
                      >
                        Sign Up
                      </button>
                      <div className="row">
                        <div className="d-flex justify-content-between">
                          <div className="text-start fw-bold">
                            <a
                              href="#"
                              onClick={formik.handleReset}
                              class="text-capitalize link-info"
                            >
                              Reset
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            class="text-end  fw-bold link-info"
                            id="sign_up_in"
                          >
                            <Link to="/" class="text-capitalize">
                              Log In
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

const mapStateToProps = (state) => ({
  loading: state.authReducer.loading,
});

const mapDispatchToProps = (dispatch) => ({
  signUpSuccess: (username, password, name, email, phoneNumber) =>
    dispatch(signUpSuccess(username, password, name, email, phoneNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpRegister);
